import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  label: { color: 'white !important' },
  form: { minWidth: 100 },
});
